<template>
  <div class="content">
    <div class="bottom">
      <div class="box">
        <div class="header">
          <div
            :class="is_status == 1 ? 'btn btnCurrent' : 'btn'"
            @click="is_status = 1"
          >
            全部订单
          </div>
          <div
            :class="is_status == 2 ? 'btn btnCurrent' : 'btn'"
            @click="is_status = 2"
          >
            待处理
          </div>
          <div
            :class="is_status == 3 ? 'btn btnCurrent' : 'btn'"
            @click="is_status = 3"
          >
            已完成
          </div>
        </div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="订单编号" width="180">
          </el-table-column>
          <el-table-column prop="name" label="服务信息" width="180">
          </el-table-column>
          <el-table-column prop="address" label="服务规格"> </el-table-column>
          <el-table-column prop="address" label="价格"> </el-table-column>
          <el-table-column prop="address" label="提交时间"> </el-table-column>
          <el-table-column prop="address" label="订单状态"> </el-table-column>
          <el-table-column prop="address" label="操作">
            <el-button type="text">订单详情</el-button>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      is_status: 1,
      page: 0,
      total: 0,
      tableData: []
    };
  },
  mounted() {
    if (this.$route.query.jude) {
      this.is_status = this.$route.query.jude;
    }
  },
  methods: {
    addSlice(index) {
      this.$router.push({
        path: `adSign?jude=${index}`
      });
    },
    // 分頁
    handleCurrentChange(val) {
      console.log("val", val);
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  background: #fff;
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: 56px;
    font-size: 14px;
    color: #595961;
    line-height: 34px;
    padding: 11px 0;
    display: flex;
    .btn {
      width: 100px;
      height: 36px;
      text-align: center;
      border-radius: 6px;
      margin-right: 5px;
      cursor: pointer;
      color: #2589ff;
    }
    .btnCurrent {
      color: #fff;
      background: #2589ff;
    }
  }
  .bottom {
    flex: 1;
    overflow-y: auto;

    .box {
      background: #f2f2f6;
      border-radius: 6px;
      padding: 10px;
    }
    .header {
      height: 56px;
      font-size: 14px;
      color: #595961;
      line-height: 34px;
      padding: 11px 0;
      display: flex;
      background-color: #fff;
      margin-bottom: 10px;
      border-radius: 10px;
      padding: 10px;
      .btn {
        width: 100px;
        height: 36px;
        text-align: center;
        border-radius: 6px;
        margin-right: 5px;
        cursor: pointer;
      }
      .btnCurrent {
        color: #fff;
        background: #2589ff;
      }
    }

    .el-table {
      border-radius: 6px;
    }
  }
  .el-pagination {
    padding-top: 20px;
    height: 60px;
    border-top: 1px solid #eee;
  }
}
</style>
